import {useSelector} from "react-redux";
import {Link, useLocation} from "react-router-dom";
import React, {Fragment, useEffect, useState} from "react";
import {createTheme, ThemeProvider} from "@mui/material";
import '../../css/Styles.css';
import {RootState} from "../../redux/store";

interface MenuData {
    menuLevel: number;
    menuCode: string;
    menuUrl: string;
    menuName: string;
    upperMenuCode: string;
}

interface MenuCode {
    menuCode: string;
}

function Sidebar({menuCode}: MenuCode) {
    const location = useLocation();
    const auth = useSelector((state: RootState) => state.loginAuth.value);
    const [menuData, setMenuData] = useState<MenuData[]>([]);
    const [isOpenArray, setIsOpenArray] = useState<boolean[]>([]);

    useEffect(() => {
        const menuAuth = Object.values(auth.MENUAUTH)
        const sortedMenuData = menuAuth
            .filter(menu => menu.readAuthorityYn === "1")
            .sort((a, b) => a.menuOrder - b.menuOrder);
        setMenuData(sortedMenuData);

        setIsOpenArray(Array(sortedMenuData.length).fill(true));

    }, []);

    // 동적으로 상태를 업데이트하는 함수 생성
    const handleOpenClick = (index: number) => {
        setIsOpenArray(prevState => {
            const newState = [...prevState];
            newState[index] = !newState[index];
            return newState;
        });
    };

    const handleClick = (to: string) => (e: React.MouseEvent<HTMLSpanElement>) => {
        if (location.pathname === to) {
            e.preventDefault();
            window.location.reload();
        }
    };

    const theme = createTheme({
        typography: {
            fontFamily: 'NotoSansKR, Malgun Gothic, 맑은 고딕, Dotum, 돋움, Helvetica Neue, Helvetica, Apple SD Gothic Neo, sans-serif',
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    '@global': {
                        '@font-face': {
                            fontFamily: 'NotoSansKR',
                            src: `local('NotoSansKR'),
            url('./assets/fonts/NotoSansKR-Regular.otf') format('opentype')`,
                        },
                        body: {
                            fontFamily: 'NotoSansKR, Malgun Gothic, 맑은 고딕, Dotum, 돋움, Helvetica Neue, Helvetica, Apple SD Gothic Neo, sans-serif !important',
                        },
                    },
                },
            },
        },
    });

    return (
        <div>
            <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

                {/*Sidebar - Brand*/}
                <Link to={auth.firstUrl} onClick={handleClick(auth.firstUrl)}
                      className="sidebar-brand d-flex align-items-center justify-content-center">
                    <div className="sidebar-brand-text mx-3" id="text">TELECONS</div>
                </Link>

                {/*Divider*/}
                <hr className="sidebar-divider my-0"/>
                <ThemeProvider theme={theme}>
                    {menuData
                        .filter((menu) => menu.menuLevel === 1)
                        .map((menu, index) => (
                        <Fragment key={menu.menuCode}>
                            {menu.menuUrl ? (
                                <li className="nav-item" id={menu.menuCode === menuCode ? 'highlight' : ''}>
                                    <Link to={menu.menuUrl} onClick={handleClick(menu.menuUrl)} className="nav-link">
                                        <span id="text" className={menu.menuCode === menuCode ? "highlight" : ""}>{menu.menuName}</span>
                                    </Link>
                                </li>
                            ) : (
                                <>
                                    <li className="nav-item">
                                        <button onClick={() => handleOpenClick(index)} className="nav-link">
                                            <span style={{ marginRight: '4rem' }}>{menu.menuName}</span>
                                            {isOpenArray[index] ? (
                                                <img width="20" height="20" src="https://img.icons8.com/ios/50/FFFFFF/collapse-arrow--v1.png" alt="collapse-arrow--v1" />
                                            ) : (
                                                <img width="20" height="20" style={{ transform: 'rotate(-180deg)' }} src="https://img.icons8.com/ios/20/FFFFFF/collapse-arrow--v1.png" alt="collapse-arrow--v1" />
                                            )}
                                        </button>
                                    </li>
                                    {/* 하위 메뉴 렌더링 */}
                                    {isOpenArray[index] && (
                                        <ul>
                                            {menuData
                                                .filter((subMenu) => subMenu.upperMenuCode === menu.menuCode)
                                                .map((subMenu) => (
                                                    <Fragment key={subMenu.menuCode}>
                                                        <hr className="sidebar-divider my-0"/>
                                                        <li key={subMenu.menuCode} className="nav-item link" id={subMenu.menuCode === menuCode ? 'highlight' : ''}>
                                                            <Link to={subMenu.menuUrl}
                                                                  onClick={handleClick(subMenu.menuUrl)}
                                                                  className="nav-menu">
                                                                {subMenu.menuCode === menuCode ? (<img width="15" height="15" className="arrow"
                                                                     src="https://img.icons8.com/material-outlined/24/4e73df/forward-arrow.png"
                                                                     alt="forward-arrow"/>) :
                                                                (<img width="15" height="15" className="arrow"
                                                                     src="https://img.icons8.com/material-outlined/24/FFFFFF/forward-arrow.png"
                                                                     alt="forward-arrow"/>)}
                                                                <span id="text"
                                                                      className={subMenu.menuCode === menuCode ? "highlight" : ""}>{subMenu.menuName}</span>
                                                            </Link>
                                                        </li>
                                                    </Fragment>
                                                ))
                                            }
                                        </ul>
                                    )}
                                </>
                            )}
                            <hr className="sidebar-divider my-0" />
                        </Fragment>
                    ))}
            </ThemeProvider>
            </ul>
        </div>
    );
}

export default Sidebar;